import React from "react";
import { Container, Grid, makeStyles } from "@material-ui/core";
import NtkHeader from "../common/NtkHeader";
import NtkParagraph from "../common/NtkParagraph";
import NtkCard from "../common/NtkCard";

const useStyles = makeStyles((theme) => ({
  grid: {
    display: "flex",
    justifyContent: "center",
  },
  contain: {
    textAlign: "center",
  },
}));
const WhatAndWhy = ({ header, paragraph, cardData }) => {
  const classes = useStyles();
  return (
    <>
      <Container className={classes.contain} maxWidth="lg">
        <NtkHeader header={header} />
        <NtkParagraph paragraph={paragraph} />
      </Container>
      <Grid container className={classes.grid}>
        {cardData &&
          cardData.map(({ id, image, header, paragraph }) => (
            <NtkCard
              key={id}
              image={image}
              header={header}
              paragraph={paragraph}
            />
          ))}
      </Grid>
    </>
  );
};

export default WhatAndWhy;
